import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface TaskChartData {
  period: string;
  completed: number;
  newTasks: number;
}

interface TasksChartProps {
  data: TaskChartData[];
}

const TasksChart: React.FC<TasksChartProps> = ({ data }) => {
  // Custom tooltip
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="dashboard-chart-tooltip">
          <p className="dashboard-chart-tooltip-label">{payload[0].payload.period}</p>
          {payload.map((entry: any, index: number) => (
            <p key={index} className="dashboard-chart-tooltip-value" style={{ color: entry.color }}>
              {entry.name}: {entry.value}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="dashboard-chart-wrapper">
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
          <XAxis
            dataKey="period"
            angle={-45}
            textAnchor="end"
            height={80}
            tick={{ fill: '#666666', fontSize: 12 }}
          />
          <YAxis
            tick={{ fill: '#666666', fontSize: 12 }}
            label={{ value: 'Tasks', angle: -90, position: 'insideLeft', fill: '#666666' }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar dataKey="completed" fill="#28a745" name="Completed" radius={[4, 4, 0, 0]} />
          <Bar dataKey="newTasks" fill="#333333" name="New Tasks" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TasksChart;

